export default __webpack_public_path__ + "static/media/g2490.977ddd48.svg";